const formularioProf = {
  formId: "distribucion-Grupo",
  formField: {
    distribucion_grupo: {
      name: "distribucion_grupo",
      label: "Grupo",
      type: "text",
    },
    profesor: {
      name: "profesor",
      label: "Profesor",
      type: "text",
    },
    asignatura: {
      name: "asignatura",
      label: "Asignatura",
      type: "text",
    },
    estudiante: {
      name: "estudiante",
      label: "Estudiante",
      type: "text",
    },
    estudiantes: {
      name: "estudiantes",
      label: "Estudiantes",
      type: "text",
    },
  },
};
export default formularioProf;
